import { render, staticRenderFns } from "./warn.vue?vue&type=template&id=4f727e8c&scoped=true&"
import script from "./warn.vue?vue&type=script&lang=js&"
export * from "./warn.vue?vue&type=script&lang=js&"
import style0 from "./warn.vue?vue&type=style&index=0&id=4f727e8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f727e8c",
  null
  
)

export default component.exports